const _customObj = {
  root: {
    padding: "0px",
  },
};

export default _customObj;
